import { InjectionToken } from '@angular/core';

import type { Attribute } from '@recruitee/http-types';

import { OverlayOriginDirective } from '../core/overlay/overlay.module';

export interface ListTemplateContext {
  $implicit: {
    attributes: Attribute[];
    suggestionsLoading: boolean;
    canPick: boolean;
    canCreate: boolean;
    toggleDropdown: (origin: OverlayOriginDirective) => void;
    dropdownOpened: boolean;
  };
}

export type AttributesTranslationsType = {
  notFound?: string;
  emptyResults: string;
  placeholder: string;
  noAbilityToCreateAttr?: string;
  attrAlreadyExists?: string;
  createNewAttr?: string;
  maxLengthExceeded?: string;
};

export enum TranslationsContext {
  Tags = 'tags',
  Sources = 'sources',
  Acquisition = 'acquisition',
  Departments = 'departments',
  WorkflowTemplates = 'workflow_templates',
}

export type TranslationsContextType = `${TranslationsContext}`;

export const RtUIAttributesTranslations = new InjectionToken('RtUIAttribuesTranslations');
export type RtUIAttributesTranslationsContexts = Record<string, AttributesTranslationsType>;
export const provideAttributesTranslations = (translations: RtUIAttributesTranslationsContexts) => [
  { provide: RtUIAttributesTranslations, useValue: translations },
];

export interface AttributesLoadMore {
  page: number;
  limit: number;
  query: string;
}

export const CREATE_NEW_ITEM_ID = 'create_new';
